import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { select } from 'd3-selection';
import { isEqual } from 'lodash';

export default class Graphs extends Component {
  static propTypes = {
    data: PropTypes.array,
    size: PropTypes.array,
    colorScheme: PropTypes.array,
    onAreaClick: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      size: props.size
    }
  }

  componentDidMount() {
    this.renderChart()
  }

  componentDidUpdate(props) {
    if (!isEqual(props.data, this.props.data) || !isEqual(props.size, this.props.size)) {
      if (this.node) {
        select(this.node).selectAll('*').remove();
      }
      return this.renderChart();
    }
    else
      return; // don't do any updates
  }

  renderChart = () => null

  render() {
    return (<svg
      ref={node => this.node = node}
      width={this.props.size[0]}
      height={this.props.size[1]}
      className={this.state.className}
      style={{ overflow: 'visible' }}
    />);
  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/Graphs.js